import {useReactFlow, type Node} from '@xyflow/react'
import {useRef, type MouseEvent, type RefObject} from 'react'

export const useNodeDragConstraint = (
  containerRef: RefObject<HTMLDivElement | null>,
  onNodeMoved: (nodeId: string, x: number, y: number) => void
) => {
  const {screenToFlowPosition, setNodes} = useReactFlow()
  const dragStartPos = useRef<{x: number; y: number} | null>(null)

  const onNodeDragStart = (_event: MouseEvent, node: Node) => {
    dragStartPos.current = {x: node.position.x, y: node.position.y}
  }

  const onNodeDragStop = (_event: MouseEvent, node: Node) => {
    if (!containerRef.current) {
      onNodeMoved(node.id, node.position.x, node.position.y)
      return
    }

    const rect = containerRef.current.getBoundingClientRect()
    const topLeft = screenToFlowPosition({x: rect.left, y: rect.top})
    const bottomRight = screenToFlowPosition({x: rect.right, y: rect.bottom})

    const isOutside =
      node.position.x < topLeft.x ||
      node.position.y < topLeft.y ||
      node.position.x > bottomRight.x ||
      node.position.y > bottomRight.y

    if (isOutside && dragStartPos.current) {
      const {x, y} = dragStartPos.current
      setNodes((nds) => nds.map((n) => (n.id === node.id ? {...n, position: {x, y}} : n)))
    } else {
      onNodeMoved(node.id, node.position.x, node.position.y)
    }

    dragStartPos.current = null
  }

  return {onNodeDragStart, onNodeDragStop}
}
